import styled from "styled-components";
import StatusTag from "./StatusTag";

const StatusTagGroup = styled.div`
  > ${StatusTag} {
    margin-right: 0.5rem;

    &:last-child {
      margin-right: 0;
    }
  }
`;

export default StatusTagGroup;
